import React from 'react'
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/AIPharmaExchange._logo.svg';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';

const Mainheader = () => {
  return (
    <div > 
    <Navbar expand="lg" className="navbar shadow-sm navbar-expand-lg navbar-light bg-white fixed-top">
      <Container >
        <Navbar.Brand as={Link} to="/"><img src={logo} alt='Employment Exchange' className='img-fluid logo' style={{width:320}} /></Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          { <Nav
            className="m-auto my-2 my-lg-0 " 
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            
                      
            <Nav.Link as={Link} to="/">Home</Nav.Link>      
             <Nav.Link as={Link} to="/Aboutus">About Us </Nav.Link>
             <Nav.Link as={Link} to="/Services">Services  </Nav.Link>
             <Nav.Link as={Link} to="/Solutions">Solutions </Nav.Link>
             <Nav.Link as={Link} to="/Careers">Careers  </Nav.Link>
             <Nav.Link as={Link} to="/Contact">Contact Us </Nav.Link>
               
            
  </Nav>}
       
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button className='rounded-button '>Sign Up <i class="bi bi-arrow-right"></i></button>
          <button className='simple-button  '>Login </button>
          </div>              
            
          

        </Navbar.Collapse>
      </Container>
    </Navbar>
    
    </div>
  )
}

export default Mainheader
